import { React, useState, useContext, useEffect } from 'react';
import * as Utilities from '../../../Components/Utils/Utils';
import * as Api from '../../../api/Api';
import { useGetToken } from '../../../Hooks/CustomHooks';
import Modal from 'react-bootstrap/Modal';
import { FeedbackContext } from "../../../Components/Context/FeedbackContext";
import * as KeyNames from '../../../api/KeyNames';
import { useQuery } from 'react-query';
import { Loading } from '../../../Components/Loading/Loading';
import { SessionContext } from '../../../Components/Context/SessionContext';
import { ErrorConnection } from "../../../Components/Error/Error";

export default function FormularioRegistroCierre({ dataSetRegistrar: dataSetRegistrarX, setGuardadoExitoso }) {

    const [dataSetRegistrar, setDataSetRegistrar] = useState(dataSetRegistrarX);

    const tokenn = useGetToken();
    const { session, setSession } = useContext(SessionContext);
    const idLocatario = (localStorage.getItem('idLocatario')) ? localStorage.getItem('idLocatario') : session.idUsuarioLocatario
    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);

    const [updateCierre, setUpdateCierre] = useState(false);
    const [showButtonUpdateCierre, setShowButtonUpdateCierre] = useState(true);

    let { data, isLoading } = useQuery([KeyNames.SessionRespuesta,
    {
        s: "s",
        idLocatario: idLocatario,
        dataSetRegistrar: dataSetRegistrar,
        token: tokenn
    }],
        async () => await Api.SetRegistrarCierreVentas_Locatario(
            {
                idLocatario: idLocatario,
                dataSetRegistrar: dataSetRegistrar,
                token: tokenn
            }
        ),
        {
            enabled: Boolean(updateCierre)
        });

    useEffect(() => {
        if (data) {
            if (!data.success)
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
            else {
                console.log(data);
                setUpdateCierre(false);
                setGuardadoExitoso(true);
                setShowButtonUpdateCierre(false);
            }
        }
    }, [data]);

    return (
        <>
            <div className="row">
                {
                    dataSetRegistrarX.suministros.map((suministro, i) => {
                        return (
                            <div className="col-md-6 " key={suministro.idSuministro}>
                                <div className='card card-body p-lg-17'>
                                    <h1 className="fw-bolder text-dark mb-9">{suministro.descripcion}</h1>
                                    <div className="row mb-5">

                                        <div className="col-md-6 fv-row ">
                                            <label className='fs-5 fw-bold mb-2'>Venta sin incluir IGV</label>
                                            <input
                                                className='form-control form-control-solid'
                                                type="number"
                                                value={dataSetRegistrar.suministros[i].venta}
                                                onChange={(e) =>
                                                    setDataSetRegistrar({
                                                        ...dataSetRegistrar,
                                                        suministros: [...dataSetRegistrar.suministros.slice(0, i),
                                                        { ...dataSetRegistrar.suministros[i], venta: Number(e.target.value) },
                                                        ...dataSetRegistrar.suministros.slice(i + 1)
                                                        ]
                                                    })
                                                }
                                            />


                                        </div>
                                        <div className="col-md-6 fv-row ">
                                            <label className='fs-5 fw-bold mb-2'>N. Transacciones</label>
                                            <input
                                                className='form-control form-control-solid'
                                                type="number"
                                                value={dataSetRegistrar.suministros[i].transacciones}
                                                onChange={(e) =>
                                                    setDataSetRegistrar({
                                                        ...dataSetRegistrar,
                                                        suministros: [...dataSetRegistrar.suministros.slice(0, i),
                                                        { ...dataSetRegistrar.suministros[i], transacciones: Number(e.target.value) },
                                                        ...dataSetRegistrar.suministros.slice(i + 1)
                                                        ]
                                                    })
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            <div className="row" style={{ textAlign: 'center', marginTop: 30 }}>
                <div className="col-12">
                    {isLoading ? (
                        <span style={{ marginLeft: 15 }}><Loading /></span>
                    ) : (
                        showButtonUpdateCierre && (
                            <button disabled={isLoading} type="submit" className="btn btn-primary" onClick={() => setUpdateCierre(true)}>Registrar</button>
                        )
                    )}
                </div>
            </div>
        </>
    )
}